import { CreateCSSProperties } from "@material-ui/styles";

export const h1: CreateCSSProperties = {
  color: "#15222f",
  fontFamily: "DM Serif Display",
  fontSize: 73,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
};

export const h2: CreateCSSProperties = {
  fontFamily: "DM Serif Display",
  fontWeight: 400,
  fontSize: 58,
  lineHeight: "normal",
  color: "#15222F",
  fontStyle: "normal",
};

export const h4Medium: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: 25,
  lineHeight: "32px",
  color: "#15222F",
};

export const h6Regular: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontWeight: 400,
  fontSize: 17,
  lineHeight: "20px",
  color: "#15222F",
};

export const h6Medium: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: 17,
  lineHeight: "20.4px",
};

export const h7Regular: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontWeight: "normal",
  fontSize: 13,
  lineHeight: "16px",
  color: "#15222F",
};

export const h5Medium: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: 19,
  lineHeight: "24px",
};

export const h5Semibold: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: 19,
  lineHeight: "24px",
};

export const h5Regular: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontWeight: "normal",
  fontSize: 19,
  lineHeight: "24px",
  color: "#15222F",
};

export const h4Light: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontStyle: "normal",
  fontWeight: 300,
  fontSize: 25,
  lineHeight: "32px",
  color: "#15222F",
};

export const h6Semibold: CreateCSSProperties = {
  fontFamily: "Barlow, Assistant",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: 17,
  lineHeight: "20.4px",
};
